import { Injectable } from '@angular/core';
import { ViewControl } from '../ui/controls/view-control.model';
import { ToggleControl } from '../ui/controls/toggle-control.model';
import { DateControl } from '../ui/controls/date-control.model';
import { SelectControl } from '../ui/controls/select-control.model';
import { BaseControl } from '../ui/controls/base-control.model';
import { UiGroupControl } from '../ui/controls/ui-group-control.model';
import { SortDescriptor, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { AuthenticationService } from '../../core/services/authentication.serivce';

/**
 *
 * Generates and holds our post data for searches
 * 
 */

@Injectable({
  providedIn: 'root'
})
export class SearchPostDataService {

  postData: any;

  constructor(private auth: AuthenticationService) { }

  getPostData(sortInfo?: SortDescriptor[], filterInfo?: CompositeFilterDescriptor): any {

    if (sortInfo != undefined && sortInfo != null && sortInfo.length > 0 && sortInfo[0].dir != undefined) {
      this.postData['sortInfos'] = sortInfo;
    } else {
      this.postData['sortInfos'] = null;
    }

    if (filterInfo != undefined && filterInfo.filters != undefined && filterInfo.filters.length > 0) {
      this.postData['filterInfo'] = filterInfo;
    } else {
      this.postData['filterInfo'] = null;
    }

    return this.postData;
  }

  buildPostData(views: ViewControl[]): any {
    var session = this.auth.getSession();

    var postData: { [k: string]: any } = {};

    postData['organizationId'] = session?.organizationId;

    if (views != undefined) {
      var controls = this.flatten(views);
      for (var i = 0; i < controls.length; i++) {
        var control = controls[i];
        var value = Reflect.get(control, "value");

        var tempValue: any;
        if (control instanceof DateControl || control instanceof ToggleControl) {
          tempValue = value;
        } else if (control.className == "SelectControl") {
          var select = control as SelectControl;
          if (select.allowMultiple === false) {
            if (select.singleValue && typeof select.singleValue === 'object') {
              tempValue = select.singleValue[select.valueMember];
            } else {
              tempValue = null;
            }
          } else {
            if (select.value) {
              var values = select.value.map(v => v[select.valueMember]);
              tempValue = values.join("\n");
            } else {
              tempValue = null;
            }
          }
        } else {
          tempValue = String(value);
        }

        if (tempValue !== undefined && tempValue !== null && tempValue !== "" && tempValue !== "null") {
          var postAsArray = Reflect.get(control, "postAsArray");
          var postArray = Boolean(postAsArray);
          if (postArray === true) {
            if (tempValue != null && tempValue.length > 0) {
              if (tempValue.includes("\n")) {
                postData[control.id] = tempValue.split("\n");
              } else {
                postData[control.id] = [tempValue];
              }
            } else {
              postData[control.id] = [];
            }
          } else {
            postData[control.id] = tempValue;
          }
        }
      }
    }

    this.postData = postData;
    return postData;
  }

  private flatten(views: ViewControl[]): BaseControl[] {
    var arrs: BaseControl[][] = views.map(v => {

      const view: ViewControl = { ...v };
      var ctrls = view.controls;

      var rows = ctrls.map(g => (g as UiGroupControl).rows);
      var arrRows = rows.reduce((accumulator, value) => accumulator.concat(value), []);

      var controls = arrRows.map(r => r.controls);
      var arrControls = controls.reduce((accumulator, value) => accumulator.concat(value), []);

      return arrControls;
    });

    return arrs.reduce((accumulator, value) => accumulator.concat(value), []);
  }

}
